export default "__VITE_ASSET__a81c4198__"